"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";

/**
 * FAQ inline en la landing — coincide con el JSON-LD FAQPage de layout.tsx.
 * Si cambia esto, actualizar también el FAQ schema.
 */

const FAQ_ITEMS = [
  {
    q: "¿Qué es Finbo?",
    a: "Finbo es una app argentina de finanzas personales que te ayuda a entender y controlar tus gastos. Es 100% gratuita y está pensada para que cualquier persona empiece a tomar el control de su plata, sin importar si nunca antes manejó un presupuesto.",
  },
  {
    q: "¿Es realmente gratis?",
    a: "Sí. La descarga, el registro y todas las funciones de control de gastos son gratis. No hay costos ocultos, ni publicidad invasiva, ni venta de datos.",
  },
  {
    q: "¿Cómo funciona el control de gastos?",
    a: "Clasificás tus movimientos en cuatro categorías: ingresos, costos fijos, costos variables y gastos hormiga. Finbo te muestra en tiempo real a dónde se va cada peso, sobre todo los chiquitos que normalmente no ves.",
  },
  {
    q: "¿Cuándo voy a poder invertir desde Finbo?",
    a: "Las inversiones (acciones, bonos, CEDEARs, FCIs) están en el roadmap para 2027. Si querés acceso temprano, escribinos a finbo.ad@gmail.com con el asunto \"Acceso temprano\" y te avisamos en cuanto abramos.",
  },
  {
    q: "¿Es segura mi información?",
    a: "Sí. Usamos encriptación, autenticación a través de AWS Cognito y no compartimos tus datos con terceros. Toda la app la construye un equipo argentino, en Argentina.",
  },
  {
    q: "¿Dónde la descargo?",
    a: "Finbo está disponible en Google Play para Android.",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section
      id="faq"
      data-section="section-faq"
      className="relative py-24 sm:py-36"
      aria-label="Preguntas frecuentes"
    >
      <div data-particle-shield className="max-w-3xl mx-auto px-5 sm:px-8">
        <div className="mb-12">
          <div className="text-[12px] tracking-[0.2em] uppercase text-white/40 mb-5">
            Preguntas frecuentes
          </div>
          <h2 className="text-[clamp(36px,5vw,60px)] font-extrabold leading-[1.05] tracking-tight">
            Lo que más <span className="text-primary">nos preguntan</span>.
          </h2>
        </div>

        <div className="border-t border-white/[0.06]">
          {FAQ_ITEMS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="border-b border-white/[0.06]"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                >
                  <span className="text-lg sm:text-xl text-white/90 group-hover:text-white transition-colors">
                    {item.q}
                  </span>
                  <span className="text-primary shrink-0">
                    {isOpen ? <Minus size={20} /> : <Plus size={20} />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <div className="pb-6 pr-12 text-white/55 leading-relaxed">
                        {item.a}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
